<template>
  <main class="login">
    <section class="login__modal" v-if="!showSuccess">
      <h2 class="login__title">{{ L.localize('Account_Breadcrumb_ForgotPassword') }}</h2>

      <form class="form js-form" data-form="login" @keydown.enter.prevent="send" @keyup.enter="send" v-if="!showSuccess">

        <span class="form__validation" v-if="error">
          {{ error }}
        </span>

        <TextBox
          label="Label_EmailAddress"
          v-model="email"
          :validate="$v"
          autocomplete="email"
          placeholder="Placeholder_Email"
          modelPath="email"
          acc="email"

          @input="$v.email.$touch"
        />

        <Btn :isLoading="loading" @click="send" label="Account_Breadcrumb_ResetPassword" />

      </form>
    </section>
     <div class="login__modal" v-else>
        <span class="form__success">
          {{ L.localize("Account_ForgotPasswordConfirmation_Text") }}
        </span>
      </div>
  </main>
</template>

<script>
  import { TextBox, Btn, CheckBox } from 'components/layout/forms'
  import L from 'services/Localization'
  import { Validation } from 'components/helpers'
  import { required } from 'vuelidate/lib/validators'
  const userService = window.abp.services.app.user

  export default {
    name: 'ForgotPassword',
    components: { Validation, TextBox, Btn, CheckBox },
    data() {
      return {
        loading: false,
        email: '',
        error: '',
        L: L,
        showSuccess: false
      }
    },
    validations: {
      email: { required }
    },
    methods: {
      send: function() {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return
        }

        let self = this
        this.loading = true
        userService.forgotPassword({ email: this.email }).done(function(response) {
          self.loading = false
          self.showSuccess = true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?06a59805